import type { InkindPageAPIModel } from '@gik/core/models/gik/InkindPage';
import moment from 'moment';

export function isInkindPageNew(inkindPage: InkindPageAPIModel): boolean {
  return inkindPage && moment.utc(inkindPage.created).isAfter(moment.utc().subtract(12, 'hours'));
}
